export const PaginationSizes = {
  DEFAULT: 25,
  INTEGRATION_MATCH_LIST: 10,
  ITEM_LIST: 25,
};
